import React, { useEffect, useState } from "react";
import { Form, Spin, Modal, Input } from "antd";
import ReferenciasApi from "../../../../../referencias/api/ReferenciasApi";
import Utils from "../../../../../../shared/helpers/utils";
import { FormConfig } from "../../../../../../shared/config/GlobalConfig";
import ReferenciaSelectFormItem from "../../../../../../shared/components/referenciaSelectFormItem";
import CampoObligatorio from "../../../../../../shared/components/campoObligatorio";

const FormItem = Form.Item;

const AnexoVElementoProteccionPersonalModal = props => {
  const [elementosProteccion, setElementosProteccion] = useState([]);
  const [working, setWorking] = useState(false);
  const [form] = Form.useForm();

  useEffect(() => {
    ReferenciasApi.GetTabla("SVCC.TELEMENTOS_PROTECCION_PERSONAL").then(response => { setElementosProteccion(response); });
  }, []);

  useEffect(() => {
    if(props.visible === true){ form.resetFields(); }
  }, [props.visible]);

  const handleOk = () => {
    form.validateFields()
      .then(values => {
        props.onOk({ 
          Hash: props.elemento ? props.elemento.Hash : Utils.generateHash(), 
          ...values 
        });
      });
  }

  return (
    <Modal 
      title={`${props.elemento ? 'Editar' : 'Agregar'} Elemento de Proteccion Personal`}
      width="60%"
      visible={ props.visible }
      onOk={ handleOk }
      onCancel={ props.onCancel }
    >
      <Spin spinning={ working }>
        <Form
          { ...FormConfig.DefaultLayout }
          form={ form }
          name="formulario"
          initialValues={{ ...props.elemento }}
          scrollToFirstError
        >
          { props.elemento?.IdElementoDeProteccion ? <FormItem name="IdElementoDeProteccion" label="Elemento de Proteccion" rules={ FormConfig.DefaultRules }>
            <Input disabled/>
          </FormItem> : '' }

          <ReferenciaSelectFormItem name="IdReferencialDeElementoDeProteccion" label="Referencial de Elemento de Proteccion" 
            rules={ FormConfig.DefaultRules } 
            tabla={ elementosProteccion }
          />

          <CampoObligatorio/>
          
        </Form>
      </Spin>
    </Modal>
  );
}

export default AnexoVElementoProteccionPersonalModal;